import { createFileRoute } from '@tanstack/react-router';
import { DeckEditor } from '../../../features/decks/deck-editor/deck-editor';

export const Route = createFileRoute('/_auth/decks/$deckId')({
  component: DeckEditorRoute,
  parseParams: (params) => ({ deckId: parseInt(params.deckId, 10) }),
  stringifyParams: (params) => ({ deckId: params.deckId.toString() }),
});

function DeckEditorRoute() {
  const { deckId } = Route.useParams();
  return <DeckEditor deckId={deckId} />;
}
